// EmptyState — presentation primitive.
// Renders a centered illustration / icon, title, description, and optional
// action slots. Selector-free, dispatch-free, prop-driven.
//
// Props:
//   icon:        string                 (Font Awesome class, optional)
//   title:       string                 (required)
//   description: string                 (optional)
//   size:        'sm'|'md'|'lg'         (default 'md')
//   illustration: ReactNode             (optional — overrides icon)
//   primaryAction:   ReactNode          (optional action slot)
//   secondaryAction: ReactNode          (optional action slot)
//   className, ...rest

function EmptyState({
  icon,
  title,
  description,
  size = 'md',
  illustration,
  primaryAction,
  secondaryAction,
  className = '',
  ...rest
}) {
  const classes = [
    'ui-empty',
    `ui-empty--${size}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {illustration ? (
        <div className="ui-empty__illustration">{illustration}</div>
      ) : icon ? (
        <span className="ui-empty__icon" aria-hidden="true">
          <i className={icon}></i>
        </span>
      ) : null}

      <h3 className="ui-empty__title">{title}</h3>

      {description ? (
        <p className="ui-empty__description">{description}</p>
      ) : null}

      {(primaryAction || secondaryAction) ? (
        <div className="ui-empty__actions">
          {primaryAction}
          {secondaryAction}
        </div>
      ) : null}
    </div>
  );
}

export default EmptyState;
